._UserClients_1hm49_1 ._text_1hm49_1 {
  display: block;
  margin-bottom: 15px;
}
._UserClients_1hm49_1 ._table_1hm49_5 ._nameCell_1hm49_5 {
  cursor: pointer;
  user-select: none;
  color: #3996e0;
}